import { render, staticRenderFns } from "./EnrolmentLayout.vue?vue&type=template&id=3b08df3e&"
import script from "./EnrolmentLayout.vue?vue&type=script&lang=js&"
export * from "./EnrolmentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports